import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "./Ourprocess.css";
import firstTabImg from "../../../Asset/tab/Slide_1.png";
import secondTabImg from "../../../Asset/tab/Slide_2.png";
import thirdTabImg from "../../../Asset/tab/Slide_3.png";
import fourthTabImg from "../../../Asset/tab/Slide_4.png";
import fifthTabImg from "../../../Asset/tab/Slide_5.png";
import sixthTabImg from "../../../Asset/tab/Slide_6.png";

const Ourprocess = () => {
  const [activeTab, setActiveTab] = useState("Requirement");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Requirement":
        return (
          <div className="tab-pane active" id="tab-0">
            <div className="tab-pane-row row">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage-img">
                  <img src={firstTabImg} alt="Requirement" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage">
                  <h3>Project Initiation</h3>
                  <ul className="process-stage-data">
                    <li>
                      Every successful software development project starts with
                      a clear understanding of the requirements provided by the
                      client.
                    </li>
                    <li>
                      To identify and develop the project scope, our business
                      analysts (BA) collaborate directly with clients.
                    </li>
                    <li>
                      We seek to create precise objectives, identify critical
                      components, and prioritize deliverables through in-depth
                      talks and analysis.
                    </li>
                    <li>
                      Through in depth analysis and discussions, we establish
                      the framework for effective project completion.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      case "Design":
        return (
          <div className="tab-pane active" id="tab-1">
            <div className="tab-pane-row row">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage-img">
                  <img src={secondTabImg} alt="Design" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage">
                  <h3>Design and Estimation </h3>
                  <ul className="process-stage-data">
                    <li>
                      Once the scope of the project has been identified, our
                      dedicated Project Manager undertakes control of the
                      project.
                    </li>
                    <li>
                      Our skilled team works together to develop a thorough
                      project strategy and a strong architectural design.
                    </li>
                    <li>
                      We calculate the development work needed while taking into
                      account a number of variables, including complexity,
                      technological stack, and resource allocation.
                    </li>
                    <li>
                      This rigorous preparation provides a realistic timeframe
                      and assists in properly managing client expectations.
                    </li>
                    <li>
                      Our goal is to deliver high quality results that exceed
                      client expectations while maintaining effective
                      communication throughout the project lifecycle.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      case "Development":
        return (
          <div className="tab-pane active" id="tab-2">
            <div className="tab-pane-row row">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage-img">
                  <img src={thirdTabImg} alt="Development" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage">
                  <h3>Agile Development </h3>
                  <ul className="process-stage-data">
                    <li>
                      The Agile methodology drives our software development
                      process, allowing us to adapt and respond to changing
                      needs throughout the project lifecycle.
                    </li>
                    <li>
                      We divide the project into smaller, more manageable chunks
                      called sprints.
                    </li>
                    <li>
                      Our development team, comprised of competent engineers and
                      developers, collaborates to develop features and
                      functionality during each sprint.
                    </li>
                    <li>
                      Regular customer communication and feedback sessions
                      guarantee transparency and alignment with their changing
                      needs.
                    </li>
                    <li>
                      With Agile, we ensure efficient communication and
                      adaptability, fostering collaboration and customer
                      satisfaction.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      case "Testing":
        return (
          <div className="tab-pane active" id="tab-2">
            <div className="tab-pane-row row">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage-img">
                  <img src={fourthTabImg} alt="Development" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage">
                  <h3>Quality Assurance </h3>
                  <ul className="process-stage-data">
                    <li>
                      Quality assurance is an essential part of our software
                      development process.
                    </li>
                    <li>
                      We have a specialized Quality Assurance (QA) team that
                      extensively tests the application at every stage to
                      guarantee that it meets the highest requirements.
                    </li>
                    <li>
                      Our QA specialists use a variety of testing approaches,
                      including as functional testing, performance testing,
                      security testing, and so on.
                    </li>
                    <li>
                      It is essential to ensure that all components of the
                      software product work flawlessly when it is released.
                    </li>
                    <li>
                      Our QA team employs diverse testing methods like
                      functional, performance, and security testing to ensure
                      flawless software.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      case "Deployment":
        return (
          <div className="tab-pane active" id="tab-2">
            <div className="tab-pane-row row">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage-img">
                  <img src={fifthTabImg} alt="Development" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage">
                  <h3>Deployment and Support </h3>
                  <ul className="process-stage-data">
                    <li>
                      Subsequently, the development and testing processes are
                      completed, we proceed with the deployment of the software
                      into the production environment.
                    </li>
                    <li>
                      Our knowledgeable DevOps team supports a smooth transition
                      by focusing on scalability, security, and performance
                      optimization.
                    </li>
                    <li>
                      Furthermore, we offer continuing support and maintenance
                      to address any issues, provide updates, and make
                      improvements based on customer feedback.
                    </li>
                    <li>
                      Throughout the entire process, our team ensures seamless
                      integration and timely delivery to exceed client
                      expectations.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      case "Project Management":
        return (
          <div className="tab-pane active" id="tab-2">
            <div className="tab-pane-row row">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage-img">
                  <img src={sixthTabImg} alt="Development" />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-stage">
                  <h3>Dynamic Project Management </h3>
                  <ul className="process-stage-data">
                    <li>
                      We acknowledge that software development projects are
                      naturally subject to change, requiring adjustments and
                      modifications as they progress.
                    </li>
                    <li>
                      We can accept change and adapt rapidly to new requirements
                      or emerging possibilities thanks to our Agile process.
                    </li>
                    <li>
                      Our staff remains adaptable, keeping open lines of contact
                      with clients and working cooperatively to identify the
                      best solutions to meet their changing demands.
                    </li>
                    <li>
                      Our flexibility allows us to embrace evolving needs,
                      collaborating closely with clients to deliver optimal
                      solutions.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <section className="our-process-section overflow-hidden">
        <Container>
          <div className="top-text-ourProcess">
            <h2>
              OUR <span>PROCESS</span>
            </h2>
          </div>
          <ul className="tab-list d-flex">
            {[
              "Requirement",
              "Design",
              "Development",
              "Testing",
              "Deployment",
              "Project Management",
            ].map((tab) => (
              <li className="nav-item" key={tab}>
                <p
                  className={`nav-link ${activeTab === tab ? "active" : ""}`}
                  onClick={() => handleTabClick(tab)}
                >
                  {tab}
                </p>
              </li>
            ))}
          </ul>
          <div className="tab-content">{renderTabContent()}</div>
        </Container>
      </section>
    </>
  );
};

export default Ourprocess;
